<smallstack-schema-form-table [schema]="searchQuerySchema" [path]="path()"></smallstack-schema-form-table>
